import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: { base: "!text-mobile-h1 md:!text-h1" },
  variants: {
    color: {
      white: "text-white",
      primary: "text-primary",
      secondary: "text-secondary",
    },
  },
  defaultVariants: {
    color: "secondary",
  },
});

interface IProps {
  children: ReactNode;
  color?: VariantProps<typeof styles>["color"];
  className?: string;
  testId?: string;
}

const H1 = ({ children, className, color, testId }: IProps) => {
  const { base } = styles({ color, className });

  return (
    <h1 data-testid={testId} className={base({ className })}>
      {children}
    </h1>
  );
};

export default H1;
